import React from 'react';
import { Pagination } from 'antd';
import { LIST_PAGE_SIZE_OPTIONS } from './useListState';

type ListPagerProps = {
  page: number;
  pageSize: number;
  totalCount: number;
  onChange: (page: number, pageSize: number) => void;
};

/**
 * 페이지 이동 (AMZUWEB-684).
 *
 * 표(`ListTable`)에서 페이지네이션을 떼어 여기로 모은 이유 — 총건수 표기와 페이지당 개수
 * 선택을 화면마다 다르게 짜고 있었다. 부품을 나눠 두면 표를 안 쓰는 리스트(카드형 등)도
 * 같은 페이저를 쓸 수 있다.
 *
 * ⚠️ 페이지당 개수를 바꿀 때 **현재 페이지를 범위 안으로 되돌린다.** 200개씩 3페이지를 보다
 * 25개씩으로 바꾸면 3페이지는 그대로 있지만, 반대(25→200)면 3페이지가 사라져 빈 표가 된다.
 */
export const ListPager = ({ page, pageSize, totalCount, onChange }: ListPagerProps): React.JSX.Element => (
  <Pagination
    current={page}
    pageSize={pageSize}
    total={totalCount}
    showSizeChanger={true}
    pageSizeOptions={LIST_PAGE_SIZE_OPTIONS.map(String)}
    onChange={(nextPage, nextPageSize) => {
      const lastPage = Math.max(Math.ceil(totalCount / nextPageSize), 1);
      onChange(Math.min(nextPage, lastPage), nextPageSize);
    }}
    /*
      총건수는 표 위(`ListToolbar`)가 "N건이 조회되었습니다." 로 이미 말한다 —
      페이저에서 또 말하면 같은 수가 화면에 두 번 나온다.
      위치는 `_table/Table`(주문/배송관리·멀티채널)이 antd 기본을 쓰는 것과 맞춰 오른쪽이다.
    */
    style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}
  />
);
